import { render } from "./Followed.vue?vue&type=template&id=18b68698&scoped=true"
import script from "./Followed.vue?vue&type=script&lang=ts"
export * from "./Followed.vue?vue&type=script&lang=ts"

import "./Followed.vue?vue&type=style&index=0&id=18b68698&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-18b68698"

export default script